import * as Yup from 'yup';

export const validationSchemaProduct = Yup.object().shape({
  name: Yup.string()
    .required('Product Name Is Required')
    // .test(
    //   'is-valid-companyName',
    //   'Invalid Product Name',
    //   (value) => !value || /^[a-zA-Z0-9&\-',./ ]+$/.test(value)
    // )
    .max(100, 'Product Name must be at most 100 characters'),
   
});
